// Module
var code = "<span ng-class=\"{'eta-late': $ctrl.task.analysis.late > 0 }\" translate>{{$ctrl.status === 'CourierArrived' ? 'CourierArrived' : ($ctrl.status === 'CourierDeparted' ? 'Departed' : 'ETA')}}</span> ";
// Exports
export default code;